module.exports = __webpack_public_path__ + "img/logoComposite2.a248e37b.png";